import { AxiosResponse } from "axios";
import { AltiusRes } from "store/types";

import { AsyncActions, AsyncActionsParams } from "../base";

export interface IEntityTag {
  id: number;
  name: string;
}

export type CreateEntityTagData = Omit<IEntityTag, "id">;

export type UpdateEntityTagData = Partial<Omit<IEntityTag, "id">> & { id: number };

export type SyncEntityTagsData = {
  entity_type: "file" | "section" | "document" | "form";
  entity_id: number;
  tag_ids: number[];
  tag_names: string[];
};

export interface IEntityTagActions {
  getEntityTagsAction: () => Promise<IEntityTag[]>;
  createEntityTagAction: (data: CreateEntityTagData) => Promise<IEntityTag>;
  deleteEntityTagAction: (id: number) => Promise<void>;
  updateEntityTagAction: (data: UpdateEntityTagData) => Promise<IEntityTag>;
  syncEntityTagsAction: (data: SyncEntityTagsData) => Promise<IEntityTag[]>;
}

export class EntityTagActions extends AsyncActions implements IEntityTagActions {
  public constructor(params: AsyncActionsParams) {
    super(params);
  }

  public getEntityTagsAction = async (): Promise<IEntityTag[]> => {
    const {
      data: { data }
    }: AxiosResponse<AltiusRes<IEntityTag[]>> = await this.api.get({
      url: "/api/v0.0.3/entity-tags"
    });
    return data;
  };

  public createEntityTagAction = async (body: CreateEntityTagData): Promise<IEntityTag> => {
    const {
      data: { data }
    }: AxiosResponse<AltiusRes<IEntityTag>> = await this.api.post({
      url: "/api/v0.0.3/entity-tags",
      data: body
    });
    return data;
  };

  public deleteEntityTagAction = async (id: number): Promise<void> => {
    await this.api.delete({
      url: `/api/v0.0.3/entity-tags/${id}`
    });
  };

  public updateEntityTagAction = async ({ id, ...body }: UpdateEntityTagData): Promise<IEntityTag> => {
    const {
      data: { data }
    }: AxiosResponse<AltiusRes<IEntityTag>> = await this.api.patch({
      url: `/api/v0.0.3/entity-tags/${id}`,
      data: body
    });
    return data;
  };

  public syncEntityTagsAction = async (body: SyncEntityTagsData): Promise<IEntityTag[]> => {
    const {
      data: { data }
    }: AxiosResponse<AltiusRes<IEntityTag[]>> = await this.api.post({
      url: "/api/v0.0.3/entity-tags/sync",
      data: body
    });
    return data;
  };
}
